module.exports = __webpack_public_path__ + "static/media/1.36c2eeb7.jpg";